<template>
  <div class="wrapper">
    {{ text }}
  </div>
</template>
<style scoped>
div.wrapper {
  position: absolute;
  bottom: 25px;
  left: 0px;
  right: 0px;
  font-size: 14px;
  color: #888;
}
</style>
<script>
export default {
  name: "labelHorizontal",
  props: ["text"],
};
</script>
